import React from "../../../__snowpack__/pkg/react.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {Select, Divider, Input} from "../../../__snowpack__/pkg/antd.js";
import {useState} from "../../../__snowpack__/pkg/react.js";
const {Option} = Select;
import {PlusOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {AddInputModal} from "./AddInputModal.js";
export const SelectInput = (props) => {
  const [addOptions, setAddOptions] = useState([]);
  const [visible, setVisible] = useState(false);
  const [addName, setAddName] = useState("");
  const {
    formatMessage,
    options,
    mode,
    isRequire,
    Form,
    mainInfo,
    infos,
    AddAttr,
    mainForm
  } = props;
  const onNameChange = (event) => {
    setAddName("" + event.target.value);
  };
  const [selectValue, setSelectValue] = useState([]);
  const addItem = () => {
    if (!addName) {
      return;
    }
    let setMap = {};
    setMap[addName] = addName;
    setAddOptions([...addOptions, setMap]);
  };
  const selectDisabled = (dataAttr) => {
    return selectValue.length >= 5 && selectValue.findIndex((data) => {
      return data.key == Object.values(dataAttr)[0];
    }) < 0;
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AddInputModal, {
    visible,
    formatMessage,
    onCancel: () => {
      setVisible(false);
    },
    unitList: infos?.attributeUnitList,
    onChange: (values) => {
      if (values && values.value) {
        setAddOptions([...addOptions, {[values.value]: values.value}]);
      }
      setVisible(false);
    }
  }), mode ? /* @__PURE__ */ React.createElement(Form.Item, {
    label: "",
    name: `category.${mainInfo.id}.${infos.attributeId}`,
    rules: [
      {
        required: isRequire,
        message: formatMessage({
          id: "pleaseSelect"
        })
      },
      {
        type: "array",
        max: 5,
        message: formatMessage({
          id: "attributeTip"
        })
      }
    ]
  }, /* @__PURE__ */ React.createElement(Select, {
    onChange: (values) => {
      if (props?.onChange) {
        props?.onChange(`category.${mainInfo.id}.${infos.attributeId}`);
      }
    },
    maxTagCount: 2,
    labelInValue: true,
    style: {width: "100%"},
    mode: "multiple",
    showArrow: true,
    placeholder: formatMessage({
      id: "pleaseSelect"
    }),
    dropdownRender: (menu) => /* @__PURE__ */ React.createElement("div", null, menu, /* @__PURE__ */ React.createElement(Divider, {
      style: {margin: "4px 0"}
    }), infos?.attributeUnitList && infos?.attributeUnitList.length ? /* @__PURE__ */ React.createElement("div", {
      style: {padding: "4px 8px", cursor: "pointer"},
      onMouseDown: (e) => e.preventDefault(),
      onClick: () => {
        setVisible(true);
      }
    }, /* @__PURE__ */ React.createElement(PlusOutlined, null), " ", formatMessage({
      id: "addAttributeValue"
    })) : /* @__PURE__ */ React.createElement("div", {
      style: {display: "flex", flexWrap: "nowrap", padding: 8}
    }, /* @__PURE__ */ React.createElement(Input, {
      style: {flex: "auto"},
      placeholder: formatMessage({
        id: "pleaseEnter"
      }),
      onChange: onNameChange,
      onKeyDown: (event) => {
        event.stopPropagation();
      }
    }), /* @__PURE__ */ React.createElement("a", {
      style: {
        flex: "none",
        padding: "8px",
        display: "block",
        cursor: "pointer"
      },
      onClick: addItem
    }, /* @__PURE__ */ React.createElement(PlusOutlined, null), " ", formatMessage({
      id: "addAttributeValue"
    }))))
  }, options && [...options, ...addOptions, ...AddAttr]?.map((dataAttr) => /* @__PURE__ */ React.createElement(Option, {
    value: Object.values(dataAttr)[0]
  }, Object.keys(dataAttr)[0])))) : /* @__PURE__ */ React.createElement(Form.Item, {
    label: "",
    name: `category.${mainInfo.id}.${infos.attributeId}`,
    rules: [
      {
        required: isRequire,
        message: formatMessage({
          id: "pleaseSelect"
        })
      }
    ]
  }, /* @__PURE__ */ React.createElement(Select, {
    maxTagCount: 2,
    labelInValue: true,
    style: {width: "100%"},
    showArrow: true,
    placeholder: formatMessage({
      id: "pleaseSelect"
    }),
    onChange: () => {
      if (props?.onChange) {
        props?.onChange(`category.${mainInfo.id}.${infos.attributeId}`);
      }
    },
    dropdownRender: (menu) => /* @__PURE__ */ React.createElement("div", null, menu, /* @__PURE__ */ React.createElement(Divider, {
      style: {margin: "4px 0"}
    }), infos?.attributeUnitList && infos?.attributeUnitList.length ? /* @__PURE__ */ React.createElement("div", {
      style: {padding: "4px 8px", cursor: "pointer"},
      onMouseDown: (e) => e.preventDefault(),
      onClick: () => {
        setVisible(true);
      }
    }, /* @__PURE__ */ React.createElement(PlusOutlined, null), " ", formatMessage({
      id: "addAttributeValue"
    })) : /* @__PURE__ */ React.createElement("div", {
      style: {display: "flex", flexWrap: "nowrap", padding: 8}
    }, /* @__PURE__ */ React.createElement(Input, {
      style: {flex: "auto"},
      placeholder: formatMessage({
        id: "pleaseEnter"
      }),
      onChange: onNameChange,
      onKeyDown: (event) => {
        event.stopPropagation();
      }
    }), /* @__PURE__ */ React.createElement("a", {
      style: {
        flex: "none",
        padding: "8px",
        display: "block",
        cursor: "pointer"
      },
      onClick: addItem
    }, /* @__PURE__ */ React.createElement(PlusOutlined, null), " ", formatMessage({
      id: "addAttributeValue"
    }))))
  }, options && [...options, ...addOptions, ...AddAttr]?.map((dataAttr) => /* @__PURE__ */ React.createElement(Option, {
    value: Object.values(dataAttr)[0]
  }, Object.keys(dataAttr)[0])))));
};
const SelectCheckWarpper = styled.span`
  .select-checkbox {
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
  }
`;
